import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getProduct, getProducts, getMainProducts, getRelatedProducts } from 'api/Products';
import { fetchWithLanguage } from 'store/helpers';

export const fetchProducts = fetchWithLanguage('fetchProducts', getProducts);
export const fetchProduct = fetchWithLanguage('fetchProduct', getProduct);
export const fetchMainProducts = fetchWithLanguage('fetchMainProducts', getMainProducts);
export const fetchRelatedProducts = fetchWithLanguage('fetchRelatedProducts', getRelatedProducts);

const productsSlice = createSlice({
    name: 'productsSlice',
    initialState: {
        products: {},
        mainProducts: {},
        productsContent: {},
        relatedProducts: {},
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchMainProducts.fulfilled, (state, action) => {
                state.mainProducts = action.payload;
            })
            .addCase(fetchProducts.fulfilled, (state, action) => {
                state.products = action.payload;
            })
            .addCase(fetchRelatedProducts.fulfilled, (state, action) => {
                state.relatedProducts = action.payload;
            })
            .addCase(fetchProduct.fulfilled, (state, action) => {
                // TODO Adjust this!
                const newItemKey = action.payload.data.slug;

                const newItem = {
                    [newItemKey]: action.payload.data,
                };

                state.productsContent = {
                    ...state.productsContent,
                    ...newItem,
                };
            });
    },
});

export const selectProductsPage = createSelector(
    [state => state.productsState.products],
    products => products.data || {},
);

export const selectProductsContent = createSelector([state => state.productsState.productsContent], data => data || {});

export const selectMainProducts = createSelector([state => state.productsState.mainProducts], data => data.data || []);

export const selectRelatedProducts = createSelector(
    [state => state.productsState.relatedProducts],
    relatedProducts => relatedProducts.data || {},
);

export default productsSlice.reducer;
